/*
 * Types.
 */

export enum OnboardingGuidesEnum {
  /** Main admin setup guide. */
  ADMIN_SETUP = 'ADMIN_SETUP',

  /** Wizard to create the first shared inbox with workflows. */
  ADMIN_WIZARD = 'ADMIN_WIZARD',

  /** Guide to teach basics about inboxes & channels. */
  BASICS = 'BASICS',

  /** Guide to teach basics about workflows. */
  WORKFLOWS = 'WORKFLOWS',

  /** Questionnaire to gather information to customize the onboarding experience. */
  QUESTIONNAIRE = 'QUESTIONNAIRE',

  /** A popover with a simplified teammate invite flow */
  QUICK_INVITE = 'QUICK_INVITE',

  /** A popover which introduces the Sandbox Demos */
  SANDBOX_DEMO_INTRO = 'SANDBOX_DEMO_INTRO',

  /** Intial popover which gathers some basic information about a front line user when they first log in (not first admin). */
  FRONT_LINE_USER_WELCOME = 'FRONT_LINE_USER_WELCOME',

  /** Front line user setup guide (not first admin). */
  FRONT_LINE_USER_SETUP = 'FRONT_LINE_USER_SETUP',

  /** Popover requesting that they add a personal email channel. */
  FRONT_LINE_USER_ADD_EMAIL_POPOVER = 'FRONT_LINE_USER_ADD_EMAIL_POPOVER',

  /** Popover requesting that they add a personal email channel to send emails. */
  FRONT_LINE_USER_SEND_EMAIL_POPOVER = 'FRONT_LINE_USER_SEND_EMAIL_POPOVER',

  /** Mobile web dialog. */
  DESKTOP_RECOMMENDATION = 'DESKTOP_RECOMMENDATION',
}
